<div class="page-innder-body portlet light ">
  <div class="portlet-body">
    <div class="table-toolbar">
      <div class="row">
        <div class="col-md-12">
          <p-toolbar styleClass="px-0">
            <div class="p-toolbar-group-start" style="font-size:x-large;">{{ 'viewConsignments.viewYourConsignments' | transloco }}</div>
            <div class="p-toolbar-group-end">
              @if (authConfig.IsAdministrator || authConfig.IsArtist) {
                <p-button type="button" icon="fa fa-plus" [label]="'viewConsignments.addConsignment' | transloco" class="ms-2 p-button-outlined"
                  [outlined]="true" (click)="addConsignment()">
                </p-button>
              }
            </div>
          </p-toolbar>
        </div>
      </div>
    </div>
    <div class=" mt-3">
      <p-table #dt [value]="consignments" dataKey="Guid" [rowHover]="true" [paginator]="true" [rows]="15"
        [rowsPerPageOptions]="[5, 10, 25]" styleClass="p-datatable-gridlines p-datatable-striped border"
        [globalFilterFields]="['Name', 'GalleryName']" selectionMode="single" [paginator]="consignments.length > 15"
        [rows]="15" [reorderableColumns]="true" [resizableColumns]="false">
        <ng-template pTemplate="caption">
          <div class="table-header">
            <div class="d-flex justify-content-end">
              <div
                class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                <button type="button"
                  class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                  <i class="text-muted fa fa-search  icon-block icon-block--search-blue is--small"></i>
                </button>
                <input type="text"
                  class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                  (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                  [placeholder]="'viewConsignments.searchByConsignmentNameOrGalleryName' | transloco" />
                </div>
                @if (authConfig.IsAdministrator || authConfig.IsGallery) {
                  <div class="ms-3" style="width: 250px;">
                    <p-dropdown [options]="artists" [(ngModel)]="filters.ArtistId" [filter]="true" [filterBy]="'label'"
                      [optionLabel]="'label'" [optionValue]="'value'" [showClear]="true"
                      [style]="{'width':'100%','border':'1px solid white','border-radius':'5px'}"
                      [placeholder]="'viewConsignments.filterByArtist' | transloco" (onChange)="onArtistChange($event)">
                    </p-dropdown>
                  </div>
                }

                @if (authConfig.IsArtist) {
                  <div class="ms-3" style="width: 200px;">
                    <p-dropdown [options]="connectedGalleryItems" [(ngModel)]="filters.GalleryId" [filter]="true"
                      [filterBy]="'label'" [optionLabel]="'label'" [optionValue]="'value'" [showClear]="true"
                      name="galleries" [placeholder]="'viewConsignments.filterByGallery' | transloco" (onChange)="onGalleriesChanged($event)">
                    </p-dropdown>
                  </div>
                }
                <div class="ms-3" style="width: 260px;">
                  <p-dropdown [options]="consignmentStatusItems" (onChange)="onConsignmentStatusChanged($event)"
                    (onClick)="onDropdownClick()" name="filterByConsignmentStatus" autoWidth="false" [filter]="false"
                    [showClear]="true" [style]="{'width':'100%','border':'1px solid white','border-radius':'5px'}"
                    [placeholder]="'viewConsignments.filterByConsignmentStatus' | transloco">
                  </p-dropdown>
                </div>

              </div>
            </div>
          </ng-template>
          <ng-template let-rowIndex="rowIndex" pTemplate="header" let-rowData>
            <tr>
              <th [pSortableColumn]="'Name'"  style="width: 250px;">{{ 'viewConsignments.consignment' | transloco }}
                <p-sortIcon [field]="'Name'"></p-sortIcon>
              </th>
              @if (authConfig.IsAdministrator ||authConfig.IsSuperAdmin   || authConfig.IsGallery || authConfig.IsGalleryStaff) {
                <th [pSortableColumn]="'ArtistName'"
                  >
                  {{ 'viewConsignments.artist' | transloco }}
                  <p-sortIcon [field]="'ArtistName'"></p-sortIcon>
                </th>
              }
              @if (authConfig.IsAdministrator ||authConfig.IsSuperAdmin  || authConfig.IsArtist) {
                <th [pSortableColumn]="'GalleryName'"
                  >{{ 'viewConsignments.gallery' | transloco }}
                  <p-sortIcon [field]="'GalleryName'"></p-sortIcon>
                </th>
              }
              <th [pSortableColumn]="'NumberOfConsignmentProducts'">{{ 'viewConsignments.artworks' | transloco }}
                <p-sortIcon [field]="'NumberOfConsignmentProducts'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'Status'" style="width: 200px;">{{ 'viewConsignments.status' | transloco }}
                <p-sortIcon [field]="'Status'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'CreatedDated'" style="width: 200px;">{{ 'viewConsignments.createdDate' | transloco }}
                <p-sortIcon [field]="'CreatedDated'"></p-sortIcon>
              </th>
              <th>
                <div class="d-flex justify-content-end px-2">{{ 'viewConsignments.actions' | transloco }}</div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData>
            <tr>
              <td class="p-3">
                @if (authConfig.IsAdministrator ||authConfig.IsSuperAdmin || authConfig.IsArtist) {
                  <a href="javascript:void(0);" class="" (click)="navigateToConsignment(rowData)">{{rowData.Name}}</a>
                }
                @if (authConfig.IsGallery || authConfig.IsGalleryStaff) {
                  <div class="">{{rowData.Name}}</div>
                }
                @if (rowData.Commission) {
                  <div class="text-muted small">{{ 'viewConsignments.withCommission' | transloco: { commission: rowData.Commission } }}</div>
                }
              </td>
              @if (authConfig.IsAdministrator ||authConfig.IsSuperAdmin  || authConfig.IsGallery || authConfig.IsGalleryStaff) {
                <td
                  >
                  {{rowData.ArtistName }}
                  <div class="text-muted small">{{rowData.ArtistPhoneNumber }}</div>
                </td>
              }
              @if (authConfig.IsAdministrator ||authConfig.IsSuperAdmin  || authConfig.IsArtist) {
                <td>
                  {{rowData.GalleryName }}
                  <div class="text-muted small">{{rowData.GalleryPhoneNumber }}</div>
                </td>
              }
              <td>
                @if (rowData.NumberOfConsignmentProducts > 0) {
                  <a href="javascript:void(0);" class="fst-italic"
                    (click)="openViewConsignmentProductsDialog(rowData)">{{ 'viewConsignments.viewArtworks' | transloco: { count: rowData.NumberOfConsignmentProducts } }}</a>
                }
              </td>
              <td>
                <div class="d-flex justify-content-start align-items-center text-muted">
                  <div class="d-flex justify-content-between align-items-center">
                    @if (!rowData.IsDispatched) {
                      <i class="fa fa-info-circle text-secondary me-2"></i> {{ 'viewConsignments.draft' | transloco }}
                    }

                    @if (rowData.IsDispatched && !rowData.HasGalleryAcceptedProducts) {
                      <!--Dispatched by the artist but not accepted by the gallery yet-->
                      <i class="fa fa-info-circle text-secondary me-2"></i>
                      {{ 'viewConsignments.dispatchedToGalleryOn' | transloco }} {{rowData.DispatchedTime | date: 'dd-MMM-yyyy'}}
                    }

                    @if (rowData.IsDispatched && rowData.HasGalleryAcceptedProducts) {
                      <!--Dispatched by the artist as well as accepted by the gallery-->
                      <i class="fa fa-check-circle text-success me-2"></i>
                      {{ 'viewConsignments.acceptedByGalleryOn' | transloco }} {{rowData.GalleryAcceptanceDate | date: 'dd-MMM-yyyy HH:mm' }}
                    }
                  </div>

                </div>
              </td>
              <td>
                {{rowData.CreatedDate | date: 'dd-MMM-yyyy HH:mm' }}
              </td>
              <td>
                <div class="d-flex justify-content-end px-2">
                  <!--View Details button is only for the administrator and the artist-->
                  @if ((authConfig.IsAdministrator || authConfig.IsSuperAdmin || authConfig.IsArtist)) {
                    <p-button type="button" icon="fa fa-arrow-circle-right" [label]="'viewConsignments.view' | transloco" class="p-button-sm"
                    [outlined]="true" (click)="navigateToConsignment(rowData)"></p-button>
                  }
                  <!-- <ng-container>
                  <p-button type="button" icon="fa fa-clock-o" label="Proposal History"
                    class="p-button-sm p-button-secondary ms-2" [outlined]="true" severity="secondary"
                  (click)="consignmentProposalDialog(rowData)"></p-button>
                </ng-container> -->
                @if (authConfig.IsGallery) {
                  @if (!rowData.HasGalleryAcceptedProducts) {
                    <!--if the gallery has not accepted the consignment already-->
                    <p-button type="button" icon="fa fa-check-circle" [label]="'viewConsignments.reviewProducts' | transloco" [outlined]="true"
                    class="p-button-primary ms-2" (click)="reviewConsignmentProducts(rowData)"></p-button>
                  }
                  <!-- "Delivery Documentation" -->
                  <p-button type="button" icon="fa fa-file-pdf-o" class=" ms-2" [outlined]="true" severity="secondary"
                  (click)="generatePdf(rowData)"></p-button>
                }
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="8">
              <div class="text-center">{{ 'viewConsignments.noRecordsFound' | transloco }}</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<p-dialog [header]="'viewConsignments.consignmentArtworks' | transloco" [(visible)]="consignmentProductsDialogVisible" [modal]="true"
  [style]="{width: '960px'}">
  <div class="container my-3">
    <div class="d-flex flex-column w-100">
      <div class="d-flex justify-content-start">
        @if (selectedConsignment && selectedConsignment.IsDispatched) {
          <div class="d-flex flex-column mb-2">
            <div class="fs-5">{{selectedConsignment.Name}}</div>
            <div class="fst-italic small">{{ 'viewConsignments.dispatchedByToGallery' | transloco: { artist: selectedConsignment.ArtistName, gallery: selectedConsignment.GalleryName } }}</div>
          </div>
        }
      </div>

      @if (consignmentProducts && consignmentProducts.length > 0) {
        <div class="row my-2">
          @for (product of consignmentProducts; track product) {
            <div class="col-6 mt-2 gallery-tile">
              <div class="position-relative">
                <!-- Custom Product Container -->
                <div class="custom-product-container border cursor-pointer" (click)="goToProductDetails(product)">
                  <div class="custom-img-container">
                    <div class="custom-img-container">
                      <img [src]="product.ResizedImageUrl ? product.ResizedImageUrl : 'assets/images/No-Image.png'"
                        class="custom-img rounded-cube border" alt="Product Image" />
                      </div>
                    </div>
                    <div class="d-flex flex-column w-100 p-2">
                      <div class="text-uppercase fw-semibold ellipsis">
                        <a href="javascript:void(0);" class="text-uppercase text-dark fw-semibold"
                          pTooltip="{{product?.Name}}">
                          {{product?.Name}}
                        </a>
                      </div>
                      <div class="d-flex flex-column small mt-2">
                        @if (product.ArtTypeName) {
                          <div class="d-flex align-items-center">
                            <div class="text-uppercase fw-semibold ">{{ 'viewConsignments.artType' | transloco }} </div>
                            <div class="text-small-muted ms-1" pTooltip="{{product.ArtTypeName}}">{{ product.ArtTypeName }}
                            </div>
                          </div>
                        }
                        @if ( product.ArtistRevenue) {
                          <div class="d-flex align-items-center">
                            <div class="text-uppercase fw-semibold ">{{ 'viewConsignments.artistRevenue' | transloco }} </div>
                            <div class="text-small-muted ms-1" pTooltip="{{product.ArtistRevenue}}">{{ product.ArtistRevenue |
                            currency:'USD':'symbol':'1.2-2'}}</div>
                          </div>
                        }
                        @if (product.CreatedDate) {
                          <div class="d-flex flex-row justify-content-between">
                            <div class="d-flex align-items-center cursor-pointer">
                              <div class="fw-semibold text-uppercase">{{ 'viewConsignments.listedDate' | transloco }} </div>
                              <div class="ms-1">{{ product.CreatedDate | date: 'dd/MM/yyyy' }}
                                @if (isToday(product.CreatedDate)) {
                                  {{ 'viewConsignments.today' | transloco }}
                                }
                                @if (!isToday(product.CreatedDate)) {
                                  {{ 'viewConsignments.daysAgo' | transloco: { days: dispatchedDaysAgo(product.CreatedDate) } }}
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
        @if (consignmentProducts.length === 0) {
          <div class="row my-2">
            <div class="col-12 text-center">{{ 'viewConsignments.noProductsFound' | transloco }}</div>
          </div>
        }
      </div>
    </div>
  </p-dialog>

  <p-dialog [header]="'viewConsignments.addConsignment' | transloco" [(visible)]="addConsignmentDialogVisible" [modal]="true" [style]="{width: '610px'}"
    class="modern-dialog">
    <div class="form-horizontal px-2 pb-1" role="form">

      <div
        class="interaction-section d-flex flex-column justify-content-center align-items-center rounded border-radius shadow ">
        <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" class="img-fluid p-2" style="max-width: 400px;"
          [alt]="'viewConsignments.logo' | transloco">
        </div>

        <div class="form-body">
          @if (authConfig.IsAdministrator && !consignmentId) {
            <div class="form-group mt-2">
              <label class="form-label">{{ 'viewConsignments.artist' | transloco }}</label>
              <small class="text-muted d-block mb-1">{{ 'viewConsignments.selectArtistForConsignment' | transloco }}</small>
              <p-dropdown [options]="artists" [(ngModel)]="artistId" [disabled]="!!consignmentId || consignment.IsDispatched"
                [placeholder]="'viewConsignments.selectArtist' | transloco" (onChange)="onArtistChange($event.value)" [filter]="true" [filterBy]="'label'"
                [optionLabel]="'label'" [optionValue]="'value'" [style]="{'width':'100%'}">
              </p-dropdown>
            </div>
          }

          <div class="form-group mt-2">
            <label class="form-label"><span class="text-danger">*</span> {{ 'viewConsignments.gallery' | transloco }}</label>
            <p-dropdown [options]="artistConnectedGalleries" [(ngModel)]="consignment.GalleryId"
              [disabled]="!!consignmentId || !artistId || consignment.IsDispatched"
              [placeholder]="!artistId ? ('viewConsignments.selectArtistFirst' | transloco) : ('viewConsignments.selectGallery' | transloco)" [filter]="true" [filterBy]="'label'"
              [optionLabel]="'label'" [optionValue]="'value'" (onChange)="onGalleryChanged($event)"
              [style]="{'width':'100%'}">
            </p-dropdown>
          </div>

          <div class="form-group mt-2">
            <label class="form-label"><span class="text-danger">*</span> {{ 'viewConsignments.name' | transloco }}</label>
            <input type="text" class="form-control" [(ngModel)]="consignment.Name" [placeholder]="getNamePlaceholder()"
              [style]="{'width':'100%'}" />
            </div>

            <div class="form-group mt-2">
              <label for="saleType" class="form-label">{{ 'viewConsignments.saleType' | transloco }}</label>
              <div class="d-flex justify-content-start">
                <div class="d-flex align-items-center">
                  <p-radioButton name="saleType" value="Consignment" [(ngModel)]="consignment.GallerySaleType"
                    inputId="saleTypeAsConsignment">
                  </p-radioButton>
                  <label for="saleTypeAsConsignment" class="ms-1">{{ 'viewConsignments.consignmentLabel' | transloco }}</label>
                </div>
                <div class="d-flex align-items-center ms-4">
                  <p-radioButton name="saleType" value="WholeSale" [(ngModel)]="consignment.GallerySaleType"
                    inputId="saleTypeAsWholeSale">
                  </p-radioButton>
                  <label for="saleTypeAsWholeSale" class="ms-1">{{ 'viewConsignments.wholesale' | transloco }}</label>
                </div>
              </div>
            </div>

            <div class="row mt-2">
              @if (consignment.GallerySaleType == 'Consignment') {
                <div class="col-6 form-group">
                  <label class="form-label">{{ 'viewConsignments.commission' | transloco }}</label>
                  <p-dropdown [options]="commissionOptions" [(ngModel)]="consignment.Commission" [disabled]="true"
                    name="Commission" [style]="{'width':'100%'}">
                  </p-dropdown>
                </div>
              }
              <div class="col-6 form-group">
                <label class="form-label">{{ 'viewConsignments.status' | transloco }}</label>
                <p-dropdown [options]="statusItem" [(ngModel)]="consignment.ConsignmentStatus"
                  [disabled]="consignment.IsDispatched" [style]="{'width':'100%'}">
                </p-dropdown>
              </div>
            </div>

            <!-- 🔥 New SalesTaxPercentage Input Field -->
            <div class="form-group mt-2">
              <label class="form-label">{{ 'viewConsignments.salesTaxPercentage' | transloco }}</label>
              <input type="number" class="form-control" [(ngModel)]="consignment.SalesTaxPercentage"
                [disabled]="true" [placeholder]="'viewConsignments.salesTaxPercent' | transloco" [style]="{'width':'100%'}" />
                @if (selectedGalleryDetails) {
                  <small class="text-muted">
                    {{ 'viewConsignments.fetchedFromGallery' | transloco: { percent: selectedGalleryDetails.SalesTaxPercentage ?? 0 } }}
                  </small>
                }
              </div>

            </div>

            <div class="d-flex justify-content-center mt-4">
              <ng-container>
                <button type="button" pButton icon="fa fa-save" [label]="'viewConsignments.saveConsignment' | transloco" (click)="saveConsignment($event)"
                  class="ms-2 p-button-outlined w-100" [disabled]="!consignment.GalleryId || !consignment.Name">
                </button>
              </ng-container>
            </div>
          </div>
        </p-dialog>
